import axios from "axios";
import PEHPLogo from "manifest-components/src/Images/logos/PEHP.png";
import SendaLogo from "manifest-components/src/Images/logos/Senda Logo.png";
import SDFLogo from "manifest-components/src/Images/logos/sunnyday_fund_logo.png";
import OneElevenLogo from "manifest-components/src/Images/logos/oneEleven.png";
import PerksLogo from "manifest-components/src/Images/logos/perks.png";
import CoreAPI from "./coreAPI";
import { SlugValidation } from "../classes/vendorConfig";

export const hardcodedPartners: string[] = ["senda", "sunnydayfund", "perks", "oneeleven"];

export type FetchEmployerListResponse = {
  employerId: string;
  employerName: string;
  employerCity: string | null;
  employerState: string | null;
  numberOfParticipants: number;
}[];

export default function APIEmployer(api: CoreAPI) {
  return {
    async fetchEmployersList(employerName = "") {
      return api.callEmployerSearch<FetchEmployerListResponse>({
        method: "GET",
        endpoint: `/employers?nameContains=${employerName}`,
      });
    },
    async fetchProviderSuggestions(employerId = "") {
      return api.callEmployerSearch<string[]>({
        method: "GET",
        endpoint: `/providersByEmployerId?employerId=${employerId}`,
      });
    },
    async fetchEmployerConfigurations(employerName = "", env: "dev" | "prod"): Promise<SlugValidation> {
      if (employerName === "pehp") {
        return {
          companyName: "PEHP",
          adminStatus: "RCM",
          presignedLogoUrl: PEHPLogo,
          companyType: "EMP",
          launchDate: new Date("2024-09-01").toDateString(),
        };
      }
      if (hardcodedPartners.includes(employerName)) {
        switch (employerName) {
          case "senda":
            return {
              companyName: "Senda",
              adminStatus: "RCM",
              presignedLogoUrl: SendaLogo,
              companyType: "PTR",
              launchDate: new Date("2024-11-01").toDateString(),
            };

          case "sunnydayfund":
            return {
              companyName: "Sunny Day Fund",
              adminStatus: "RCM",
              presignedLogoUrl: SDFLogo,
              companyType: "PTR",
              launchDate: new Date("2024-10-01").toDateString(),
            };
          case "oneeleven":
            return {
              companyName: "OneEleven",
              adminStatus: "RCM",
              presignedLogoUrl: OneElevenLogo,
              companyType: "PTR",
              launchDate: new Date("2024-06-01").toDateString(),
            };
          case "perks":
            return {
              companyName: "Perks",
              adminStatus: "RCM",
              presignedLogoUrl: PerksLogo,
              companyType: "PTR",
              launchDate: new Date("2024-08-01").toDateString(),
            };
          default:
            break;
        }
      }

      const res = await axios.get(
        `${
          env === "prod" ? "https://portal.api.usemanifest.com" : "https://portal.api.dev.usemanifest.com"
        }/authentication/validateSlug?slug=${employerName}`
      );

      return res.data.data;
    },
  };
}
